import ImageContent from "./ImageContent";

function ListContent({ list, chooseContent, contentForDelete, contentForEdit }) {
    return (
        <div className="h92 w-full overflow-auto">
            {list.map((item, index) => {
                return (
                    <div
                        className={`flex flex-row-reverse items-center justify-between text-right
                                        ${index % 2 === 0 ? "bg-slate-200" : "bg-white"}`}>
                        <div
                            onClick={() => chooseContent(item)}
                            className="flex flex-row-reverse items-center">
                            <ImageContent typeContent={item.typeContent} />
                            <p className="w-40 text-sm mr-2">{item.channelName}</p>
                            <p className="w-40 text-sm">{item.Admin}</p>
                            {item.text.length >= 57 ?
                                <p className="w-96 text-xs drtl">{item.text.substring(0, 57).concat(" ... ")}</p>
                                :
                                <p className="w-96 text-xs drtl">{item.text}</p>
                            }
                            <p className="w-40 text-sm text-slate-500">{item.date}</p>
                            <p className="w-40 text-sm text-slate-500">{item.time}</p>
                        </div>
                        <div className="flex flex-row-reverse items-center">
                            <img
                                src="/image/icon/edit.png"
                                className="w-9 mx-5"
                                onClick={() => contentForEdit(item)}
                            />
                            <img
                                src="/image/icon/delete.png"
                                className="w-6 ml-10"
                                onClick={() => contentForDelete(item.id)}
                            />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
export default ListContent;